import React from 'react'
import { NextPage } from 'next'
import { getSEOServersideProps, PagePropsWrapper } from 'lib/routing/nextPageUtils'
import { StandardLayout } from 'shared/layout/StandardLayout'
import { ObjectNotFoundError } from 'services/ContentfulService/errors'
import { getTermBySlug } from 'services/ContentfulService/hooks/term'
import { GlossaryTermPage, GlossaryTermProps } from 'experiences/learn/glossary/Term'
import { Breadcrumbs } from 'shared/layout/CustomHead/Schemas/breadcrumbSchema'
import { getAbstract } from 'components/vendor/Contentful/richText/utils'

const GlossaryTerm: NextPage<PagePropsWrapper<GlossaryTermProps>> = ({ metaTags, pageProps }) => (
	<StandardLayout
		metaTags={metaTags}
		schemas={[
			{
				'@type': 'BreadcrumbList',
				breadcrumbs: [Breadcrumbs.Learn(), Breadcrumbs.Glossary(), Breadcrumbs.TermPage(pageProps.term.name[0])]
			}
		]}
	>
		<GlossaryTermPage term={pageProps.term} />
	</StandardLayout>
)

export const getServerSideProps = getSEOServersideProps<GlossaryTermProps>(
	async ctx => {
		const { query } = ctx

		if (typeof query.term === 'string') {
			const term = await getTermBySlug(query.term)

			return {
				term
			}
		}
		throw new ObjectNotFoundError('term')
	},
	(metadataTags, pageProps) => {
		return {
			...metadataTags,
			title: `Learn About ${pageProps.term.name} | Fiona`,
			description: getAbstract(pageProps.term.definition)
		}
	}
)

export default GlossaryTerm
